/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_TitleInputs */

const en_carrier_notices_title = /** @type {(inputs: Carrier_Notices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier Notices`)
};

const es_carrier_notices_title = /** @type {(inputs: Carrier_Notices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avisos de transportistas`)
};

/**
* | output |
* | --- |
* | "Carrier Notices" |
*
* @param {Carrier_Notices_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_title = /** @type {((inputs?: Carrier_Notices_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_title(inputs)
	return es_carrier_notices_title(inputs)
});